import * as React from "react"

import { ActivityIcon } from "./ActivityIcon"
import { AlertIcon } from "./AlertIcon"
import { ArrowBackIcon } from "./ArrowBackIcon"
import { ArrowDownIcon } from "./ArrowDownIcon"
import { CalendarIcon } from "./CalendarIcon"
import { ChartsIcon } from "./ChartsIcon"
import { CheckIcon } from "./CheckIcon"
import { CrossIcon } from "./CrossIcon"
import { DeleteIcon } from "./DeleteIcon"
import { EmployeesIcon } from "./EmployeesIcon"
import { EyeIcon } from "./EyeIcon"
import { FeedbackIcon } from "./FeedbackIcon"
import { FinancialSituationIcon } from "./FinancialSituationIcon"
import { HamburgerMenuIcon } from "./HamburgerMenuIcon"
import { HealthPromotionIcon } from "./HealthPromotionIcon"
import { HeartIcon } from "./HeartIcon"
import { HomeIcon } from "./HomeIcon"
import { HourGlassIcon } from "./HourGlassIcon"
import { IdentifyingRiskIcon } from "./IdentifyingRiskIcon"
import { MeaningfulLifeIcon } from "./MeaningfulLifeIcon"
import { MentalHealthIcon } from "./MentalHealthIcon"
import { MessageIcon } from "./MessageIcon"
import { Number1Icon } from "./Number1Icon"
import { Number2Icon } from "./Number2Icon"
import { Number3Icon } from "./Number3Icon"
import { NutritionIcon } from "./NutritionIcon"
import { PdfAttachmentIcon } from "./PdfAttachmentIcon"
import { PhoneIcon } from "./PhoneIcon"
import { PlusIcon } from "./PlusIcon"
import { ReportsIcon } from "./ReportsIcon"
import { ResearchIcon } from "./ResearchIcon"
import { SearchIcon } from "./SearchIcon"
import { SendIcon } from "./SendIcon"
import { SettingsIcon } from "./SettingsIcon"
import { SignOutIcon } from "./SignOutIcon"
import { SleepRecoveryIcon } from "./SleepRecoveryIcon"
import { SocialRelationshipsIcon } from "./SocialRelationshipsIcon"
import { SortDownIcon } from "./SortDownIcon"
import { SortDownUpIcon } from "./SortDownUpIcon"
import { SortUpIcon } from "./SortUpIcon"
import { StarIcon } from "./StarIcon"
import { StarNineIcon } from "./StarNineIcon"
import { ThumbsUpIcon } from "./ThumbsUpIcon"
import { UserIcon } from "./UserIcon"
import { WorkIcon } from "./WorkIcon"

/**
 * THIS IS A GENERATED FILE, DO NOT MODIFY MANUALLY.
 * Modify .svg in src/assets/icons/ and generate code again with 'yarn generate-icons'.
 */

export type GeneratedIcon =
  | "activity"
  | "alert"
  | "arrowBack"
  | "arrowDown"
  | "calendar"
  | "charts"
  | "check"
  | "cross"
  | "delete"
  | "employees"
  | "eye"
  | "feedback"
  | "financialSituation"
  | "hamburgerMenu"
  | "healthPromotion"
  | "heart"
  | "home"
  | "hourGlass"
  | "identifyingRisk"
  | "meaningfulLife"
  | "mentalHealth"
  | "message"
  | "number1"
  | "number2"
  | "number3"
  | "nutrition"
  | "pdfAttachment"
  | "phone"
  | "plus"
  | "reports"
  | "research"
  | "search"
  | "send"
  | "settings"
  | "signOut"
  | "sleepRecovery"
  | "socialRelationships"
  | "sortDown"
  | "sortDownUp"
  | "sortUp"
  | "star"
  | "starNine"
  | "thumbsUp"
  | "user"
  | "work"

export type GeneratedIconComponents = Record<
  GeneratedIcon,
  React.FC<React.SVGProps<SVGSVGElement>>
>

export const generatedIcons: GeneratedIconComponents = {
  activity: ActivityIcon,
  alert: AlertIcon,
  arrowBack: ArrowBackIcon,
  arrowDown: ArrowDownIcon,
  calendar: CalendarIcon,
  charts: ChartsIcon,
  check: CheckIcon,
  cross: CrossIcon,
  delete: DeleteIcon,
  employees: EmployeesIcon,
  eye: EyeIcon,
  feedback: FeedbackIcon,
  financialSituation: FinancialSituationIcon,
  hamburgerMenu: HamburgerMenuIcon,
  healthPromotion: HealthPromotionIcon,
  heart: HeartIcon,
  home: HomeIcon,
  hourGlass: HourGlassIcon,
  identifyingRisk: IdentifyingRiskIcon,
  meaningfulLife: MeaningfulLifeIcon,
  mentalHealth: MentalHealthIcon,
  message: MessageIcon,
  number1: Number1Icon,
  number2: Number2Icon,
  number3: Number3Icon,
  nutrition: NutritionIcon,
  pdfAttachment: PdfAttachmentIcon,
  phone: PhoneIcon,
  plus: PlusIcon,
  reports: ReportsIcon,
  research: ResearchIcon,
  search: SearchIcon,
  send: SendIcon,
  settings: SettingsIcon,
  signOut: SignOutIcon,
  sleepRecovery: SleepRecoveryIcon,
  socialRelationships: SocialRelationshipsIcon,
  sortDown: SortDownIcon,
  sortDownUp: SortDownUpIcon,
  sortUp: SortUpIcon,
  star: StarIcon,
  starNine: StarNineIcon,
  thumbsUp: ThumbsUpIcon,
  user: UserIcon,
  work: WorkIcon,
}
